import { ValidateBalanceResponse } from 'api/endpoints/transfers/types/response'
import { ApiError } from 'types'
import { apiResponseMessages, defaultErrorMessage } from './ApiResponseMessages'
import { getCurrentUser, getStoredServices } from './authStorage'

// Sent with every validate-account-balance call
export const getBalanceValidationParams = () => ({
  customerType: getCurrentUser()?.customerInfo?.customerType,
  canUseAvailableBalance: getStoredServices().includes('USE_AVAIL_BAL_ALWAYS'),
})

export const resolveBalanceValidationKey = (
  balanceData?: ValidateBalanceResponse,
  balanceError?: ApiError,
): string => {
  if (balanceData?.message === 'INVALID_BALANCE') return 'common.error.balance.insufficient'
  if (balanceData?.message === 'MISSING_FEE') return 'common.error.balance.missing_fee'

  const code = balanceError?.data?.message || balanceData?.message
  return apiResponseMessages[code || ''] || defaultErrorMessage
}
